// extracted by mini-css-extract-plugin
export default {"container":"styles_container__F3d0h","pv_badge":"styles_pv_badge__HqHSm","content_container":"styles_content_container__eRAId","note_content":"styles_note_content__3ip+M"};